/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IColumn } from '@fluentui/react/lib/DetailsList';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { Table } from 'src/core/components/Table';
import { TableProps } from 'src/core/components/TableProps';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { Entity } from 'src/luis/projects/entities/types/Entity';

export type CompositeEntityChildrenTableProps = TableProps<Entity>;

const messages = defineMessages({
    childEntityNameColumnHeader: {
        id: 'entities.compositeEntityChildTable.childEntityNameColumnHeader',
        defaultMessage: 'Child Entity'
    },
    emptyTablePlaceholder: {
        id: 'entities.compositeEntityChildTable.emptyTablePlaceholder',
        defaultMessage: "You haven't added any children yet."
    }
});

/**
 * Represents a table of children entities for a composite entity.
 *
 * @param props The properties to pass to the table.
 */
export const CompositeEntityChildTable = (props: CompositeEntityChildrenTableProps) => {
    const { items, selection, ...rest } = props;
    const { localize } = useLocalization();

    const columns: IColumn[] = [
        {
            fieldName: 'name',
            key: 'childEntityColumn',
            name: localize(messages.childEntityNameColumnHeader),
            minWidth: 150,
            isRowHeader: true
        }
    ];

    return (
        <Table<Entity>
            emptyPlaceholder={localize(messages.emptyTablePlaceholder)}
            items={items}
            selection={selection}
            columns={columns}
            {...rest}
        />
    );
};
